import { CanActivate } from "@angular/router";
import { KpiService } from "./kpi/kpi.service";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { UserInfo } from "./shared/interfaces";

@Injectable()
export class NonAdminUserGuard implements CanActivate {
  constructor(private kpiService: KpiService, private router: Router) {}

  canActivate(): Observable<boolean> | boolean {
    return this.kpiService.getUserInfo().pipe(
      map((res: UserInfo) => {
        if (res.role && res.role == "admin") {
          return true;
        } else {
          this.router.navigate([""]);
          return false;
        }
      })
    );
  }
}
